
import React from 'react';
import { ScrollArea } from "@/components/ui/scroll-area";
import { formatDistanceToNow } from "date-fns";
import { Clock, FileText } from "lucide-react";

interface DecisionHistoryTabProps {
  decisions: {
    challenge: string;
    decision: string;
    outcome: string;
    date: Date;
  }[];
}

const DecisionHistoryTab: React.FC<DecisionHistoryTabProps> = ({ decisions }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4 flex items-center text-web3-green">
        <FileText className="mr-2 h-5 w-5" />
        Decision History
      </h3>
      
      {decisions.length === 0 ? (
        <div className="text-center py-8 text-muted-foreground">
          <p>No decisions recorded yet</p>
          <p className="text-sm">Your decision history will appear here as you face challenges</p>
        </div>
      ) : (
        <ScrollArea className="h-[240px]">
          <div className="space-y-4">
            {decisions.map((decision, index) => (
              <div 
                key={index} 
                className="border border-web3-blue/20 bg-web3-blue/5 p-4 rounded-md"
              >
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-white">{decision.challenge}</h4>
                  <div className="text-xs text-white/60 flex items-center">
                    <Clock className="h-3 w-3 mr-1" />
                    {formatDistanceToNow(new Date(decision.date))} ago
                  </div>
                </div>
                
                <div className="space-y-2">
                  <div>
                    <div className="text-xs text-white/60">Your Decision:</div>
                    <p className="text-sm text-white">{decision.decision}</p>
                  </div>
                  
                  <div>
                    <div className="text-xs text-white/60">Outcome:</div>
                    <p className="text-sm text-white">{decision.outcome}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      )}
    </div>
  );
};

export default DecisionHistoryTab;
